import Notifiq from "@/Pages/Notifiq/index.vue";
import { can } from "@/plugins/can";

const checkPermission = (permissions) => {
  return (to, from, next) => {
    if (!can(permissions)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
};

export default [
  {
    path: "/notifiq/index",
    name: "notifiq.index",
    component: Notifiq,
    beforeEnter: checkPermission(["notifiq.load"]),
  },
];
